export default __webpack_public_path__ + "static/media/polygon_token.48da6b76.png";